// Translation dictionaries for supported languages
export const translations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    customers: "Customers",
    clients: "Clients",
    estimates: "Estimates",
    jobs: "Jobs",
    invoices: "Invoices",
    settings: "Settings",
    site_visits_nav: "Site Visits",
    
    // Common actions
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    add: "Add",
    remove: "Remove",
    view: "View",
    download: "Download",
    copy: "Copy",
    share: "Share",
    send: "Send",
    approve: "Approve",
    decline: "Decline",
    search: "Search",
    filter: "Filter",
    loading: "Loading...",
    saving: "Saving...",
    adding: "Adding...",
    back: "Back",
    done: "Done",
    start: "Start",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    export: "Export",
    import: "Import",
    duplicate: "Duplicate",
    archive: "Archive",
    restore: "Restore",
    reset: "Reset",
    
    // Dashboard
    dashboard_title: "Operations",
    dashboard_subtitle: "Manage estimates, invoices, and job notes in one place.",
    new_estimate: "New Estimate",
    active_jobs: "Active Jobs",
    pending: "Pending",
    outstanding: "Outstanding",
    revenue: "Revenue",
    quick_actions: "Quick Actions",
    create_estimate: "Create Estimate",
    add_customer: "Add Customer",
    view_invoices: "View Invoices",
    estimate_pipeline: "Estimate Pipeline",
    recent_activity: "Recent Activity",
    view_all: "View all",
    approved_active: "Approved & active",
    follow_up_soon: "Follow up soon",
    all_caught_up: "All caught up",
    unpaid: "Unpaid",
    invoiced: "invoiced",
    new_site_visit: "New Site Visit",
    schedule_site_visit: "Schedule Site Visit",
    quick_estimate: "Quick Estimate",
    schedule_job: "Schedule Job",
    view_details: "View Details",
    
    // Estimates
    estimates_title: "Estimates",
    total_estimates: "total estimates",
    draft: "Draft",
    sent: "Sent",
    approved: "Approved",
    declined: "Declined",
    expired: "Expired",
    all: "All",
    create_job: "Create Job",
    create_invoice: "Create Invoice",
    converted_to_job: "Converted to Job",
    view_job: "View Job",
    send_to_client: "Send to Client",
    copy_link: "Copy Link",
    preview_pdf: "Preview PDF",
    download_pdf: "Download PDF",
    client_approval_link: "Client Approval Link",
    share_link_desc: "Share this link with your client to approve",
    preview: "Preview",
    estimate_details: "Estimate Details",
    scope_of_work: "Scope of Work",
    line_items: "Line Items",
    item: "Item",
    qty: "Qty",
    rate: "Rate",
    total: "Total",
    subtotal: "Subtotal",
    tax: "Tax",
    deposit_required: "Deposit Required",
    job_site: "Job Site",
    notes: "Notes",
    split: "Split",
    combine: "Combine",
    split_estimate: "Split Estimate",
    combine_estimates: "Combine Estimates",
    
    // Jobs
    jobs_title: "Jobs",
    schedule_manage: "Schedule and manage your jobs",
    new_job: "New Job",
    calendar: "Calendar",
    active: "Active",
    appointments: "Appointments",
    scheduled: "Scheduled",
    in_progress: "In Progress",
    completed: "Completed",
    on_hold: "On Hold",
    cancelled: "Cancelled",
    estimate_appointments: "Estimate Appointments",
    site_visits: "Site visits, pre-estimate walkthroughs, and initial meetings",
    new_appointment: "New Appointment",
    no_jobs_found: "No jobs found",
    no_appointments: "No appointments scheduled",
    job_details: "Job Details",
    assigned_crew: "Assigned Crew",
    internal_notes: "Internal Notes",
    linked_documents: "Linked Documents",
    export_calendar: "Export to Calendar",
    open_in_maps: "Open in Maps",
    today: "Today",
    month: "Month",
    week: "Week",
    list: "List",
    start_date: "Start Date",
    end_date: "End Date",
    job_type: "Job Type",
    mark_completed: "Mark Completed",
    start_job: "Start Job",
    call_client: "Call Client",
    get_directions: "Get Directions",
    visits: "Visits",
    no_jobs_scheduled_yet: "No jobs scheduled yet",
    start_by_scheduling: "Start by scheduling a site visit",
    calendar_best_on_larger: "Calendar view works best on larger screens",
    invoice_linked: "Invoice linked",
    no_site_visits_scheduled: "No site visits scheduled",
    select_a_client: "Select a client",
    select_type: "Select type",
    schedule_repeat: "Schedule this job to repeat automatically",
    weekly: "Weekly",
    biweekly: "Every 2 Weeks",
    monthly: "Monthly",
    custom_interval: "Custom Interval",
    
    // Invoices
    invoices_title: "Invoices",
    total_invoices: "total invoices",
    paid: "Paid",
    partial: "Partial",
    mark_as_paid: "Mark as Paid",
    record_payment: "Record Payment",
    payment_history: "Payment History",
    amount_due: "Amount Due",
    amount_paid: "Amount Paid",
    balance: "Balance",
    balance_due: "Balance Due",
    due_date: "Due Date",
    bill_to: "Bill To",
    no_payments: "No payments recorded",
    paid_in_full: "Paid in Full",
    share_link: "Share Link",
    payment_recorded: "Payment recorded!",
    revision_history: "Revision History",
    
    // Customers/Clients
    customers_title: "Customers",
    clients_title: "Clients",
    total_customers: "total customers",
    add_new_customer: "Add New Customer",
    add_new_client: "Add New Client",
    add_customer_btn: "Add Customer",
    add_first_customer: "Add Your First Customer",
    customer_details: "Customer Details",
    client_details: "Client Details",
    contact_info: "Contact Information",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    search_placeholder: "Search by name, email, or phone...",
    no_customers_found: "No customers found",
    no_customers_yet: "No customers yet",
    try_different_search: "Try a different search term",
    add_first_desc: "Add your first customer to get started",
    customer_added: "Customer added!",
    no_contact_info: "No contact info",
    no_email: "No email",
    no_phone: "No phone",
    
    // Site Visits
    site_visits_title: "Site Visits",
    schedule_first_visit: "Schedule your first site visit to get started",
    no_site_visits_found: "No site visits found",
    converted: "Converted",
    filter_by_status: "Filter by status",
    select_customer: "Select customer",
    select_service_type: "Select service type",
    enter_job_address: "Enter job site address",
    field_notes: "Field Notes",
    checklist: "Checklist",
    photos: "Photos",
    measurements: "Measurements",
    convert_to_estimate: "Convert to Estimate",
    
    // Settings
    settings_title: "Settings",
    manage_settings: "Manage your organization settings",
    company: "Company",
    branding: "Branding",
    payments: "Payments",
    terms: "Terms",
    defaults: "Defaults",
    users: "Users",
    data: "Data",
    language: "Language",
    business: "Business",
    team: "Team",
    documents: "Documents",
    notifications: "Notifications",
    esignatures: "E-Signatures",
    
    // Language Settings
    language_settings: "Language Settings",
    default_language: "Default Language",
    default_language_desc: "Set the default language for all users in your organization",
    user_language: "Your Language",
    user_language_desc: "Override the organization default for your account only",
    use_org_default: "Use organization default",
    
    // Terms & Conditions
    terms_conditions: "Terms & Conditions",
    terms_mode: "Terms Mode",
    use_template: "Use Professional Template (Recommended)",
    template_desc: "A comprehensive, professionally written terms template that auto-fills with your company info, deposit amounts, and payment terms.",
    use_custom: "Use Custom Terms",
    custom_desc: "Replace the template entirely with your own custom terms and conditions.",
    template_preview: "Template Preview",
    auto_fills: "Auto-fills with your company info",
    custom_terms: "Custom Terms & Conditions",
    will_replace: "Will replace template entirely",
    require_acceptance: "Require Terms Acceptance",
    require_acceptance_desc: "When enabled, clients must check a box agreeing to the terms before they can approve an estimate.",
    save_terms: "Save Terms Settings",
    
    // Checklist Settings
    checklist_settings: "Checklist Settings",
    checklist_settings_desc: "Configure checklist requirements for site visit conversions and manage checklist templates.",
    require_checklist: "Require Checklist Before Conversion",
    require_checklist_desc: "When enabled, field notes checklist must be completed before a site visit can be converted to an estimate.",
    default_checklist_items: "Default Checklist Items",
    checklist_templates: "Checklist Templates",
    checklist_templates_desc: "Reusable checklist templates for different project types.",
    new_template: "New Template",
    no_templates_yet: "No custom templates yet.",
    set_as_default: "Set as default template for new site visits",
    
    // Public pages
    estimate_valid: "This estimate is valid for {days} days from the date above.",
    view_terms: "View Terms",
    hide_terms: "Hide Terms",
    agree_terms: "I have read and agree to the Terms & Conditions",
    agree_terms_desc: "By checking this box, I acknowledge that I have reviewed the terms and conditions above and agree to be bound by them.",
    approve_estimate: "Approve Estimate",
    estimate_approved: "Estimate Approved!",
    estimate_declined: "Estimate Declined",
    thank_you: "Thank you for considering {company}!",
    questions: "Questions? Contact us at {contact}",
    
    // Forms
    required_field: "This field is required",
    invalid_email: "Please enter a valid email",
    select_option: "Select an option",
    enter_amount: "Enter amount",
    select_status: "Select status",
    
    // Dates & Time
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    this_week: "This Week",
    this_month: "This Month",
    created: "Created",
    
    // Status messages
    saved_successfully: "Saved successfully!",
    failed_to_save: "Failed to save",
    failed_to_load: "Failed to load data",
    deleted_successfully: "Deleted successfully",
    failed_to_delete: "Failed to delete",
    sent_successfully: "Sent successfully!",
    failed_to_send: "Failed to send",
    link_copied: "Link copied to clipboard!",
    pdf_downloaded: "PDF downloaded!",
    
    // Misc
    logout: "Log Out",
    profile: "Profile",
    help: "Help",
    no_results: "No results found",
    unknown_client: "Unknown Client",
    or: "or",
    of: "of",
    items: "items",
    none: "None",
    overdue: "Overdue",
    status: "Status",
    type: "Type",
    date: "Date",
    amount: "Amount",
    description: "Description",
    actions: "Actions",
    details: "Details",
    summary: "Summary",
    template: "Template",
    templates: "Templates",
    
    // Form Labels (shared across pages)
    customer_label: "Customer",
    service_type_label: "Service Type",
    job_address_label: "Job Address",
    date_label: "Date",
    time_label: "Time",
    assigned_to: "Assigned To",
    notes_label: "Notes",
    license_optional: "License # (Optional)",
    services_offered: "Services Offered",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm New Password",
    primary_color: "Primary Color",
    accent_color: "Accent Color",
    first_name: "First Name",
    last_name: "Last Name",
    role: "Role",
    
    // Site Visit Detail
    complete_checklist_to_convert: "Complete field notes checklist to enable estimate conversion",
    delete_site_visit: "Delete Site Visit",
    convert_to_estimate_title: "Convert to Estimate",
    
    // Jobs Page specific
    no_jobs_scheduled_yet: "No jobs scheduled yet",
    start_by_scheduling: "Start by scheduling a site visit",
    no_site_visits_scheduled: "No site visits scheduled",
    invoice_linked: "Invoice linked",
    calendar_best_on_larger: "Calendar view works best on larger screens",
    
    // Invoice Detail
    demo_mode_payments: "Demo Mode: Online payments simulated.",
    tip_payment_link: "Tip: This link shows your branding and payment options.",
    summary_mode_hint: "Summary Mode: Add sections with descriptions. Enter the grand total at the bottom.",
    
    // Client Detail  
    archive_client: "Archive client",
    materials_scope_ideas: "Materials & Scope Ideas",
    timeline_label: "Timeline",
    budget_label: "Budget",
    priorities_label: "Priorities",
    
    // Settings Page
    no_crew_members: "No crew members yet",
    no_esignatures: "No e-signatures yet",
    company_information: "Company Information",
    company_name: "Company Name",
    website_label: "Website",
    licensed_insured: "Licensed & Insured",
    licensed_insured_desc: "Display \"Licensed & Insured\" badge on PDFs",
    change_password: "Change Password",
    brand_colors: "Brand Colors",
    logo_preview: "Logo preview",
    estimate_settings: "Estimate Settings",
    estimate_display_modes: "Estimate Display Modes",
    estimate_modes_desc: "Choose which estimate formats are available when creating estimates.",
    save_estimate_modes: "Save Estimate Modes",
    line_items_during_visit: "Line Items During Site Visit",
    line_items_mode_desc: "Choose how line items appear when creating a new estimate.",
    required: "Required",
    optional: "Optional",
    hidden: "Hidden",
    terms_conditions_section: "Terms & Conditions",
    estimate_terms: "Estimate Terms",
    invoice_terms: "Invoice Terms",
    
    // Misc page elements
    no_data: "No data available",
    confirm_delete: "Are you sure you want to delete this?",
    this_action_cannot_be_undone: "This action cannot be undone.",
    sign_in: "Sign In",
    log_out: "Log Out",
    online: "Online",
    offline: "Offline",
  },
  
  es: {
    // Navigation
    dashboard: "Panel",
    customers: "Clientes",
    clients: "Clientes",
    estimates: "Presupuestos",
    jobs: "Trabajos",
    invoices: "Facturas",
    settings: "Configuraci\u00f3n",
    site_visits_nav: "Visitas",
    
    // Common actions
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    add: "Agregar",
    remove: "Quitar",
    view: "Ver",
    download: "Descargar",
    copy: "Copiar",
    share: "Compartir",
    send: "Enviar",
    approve: "Aprobar",
    decline: "Rechazar",
    search: "Buscar",
    filter: "Filtrar",
    loading: "Cargando...",
    saving: "Guardando...",
    adding: "Agregando...",
    back: "Volver",
    done: "Listo",
    start: "Iniciar",
    close: "Cerrar",
    confirm: "Confirmar",
    yes: "S\u00ed",
    no: "No",
    export: "Exportar",
    import: "Importar",
    duplicate: "Duplicar",
    archive: "Archivar",
    restore: "Restaurar",
    reset: "Restablecer",
    
    // Dashboard
    dashboard_title: "Operaciones",
    dashboard_subtitle: "Administre presupuestos, facturas y notas de trabajo en un solo lugar.",
    new_estimate: "Nuevo Presupuesto",
    active_jobs: "Trabajos Activos",
    pending: "Pendientes",
    outstanding: "Pendiente",
    revenue: "Ingresos",
    quick_actions: "Acciones R\u00e1pidas",
    create_estimate: "Crear Presupuesto",
    add_customer: "Agregar Cliente",
    view_invoices: "Ver Facturas",
    estimate_pipeline: "Pipeline de Presupuestos",
    recent_activity: "Actividad Reciente",
    view_all: "Ver todo",
    approved_active: "Aprobados y activos",
    follow_up_soon: "Seguimiento pronto",
    all_caught_up: "Todo al d\u00eda",
    unpaid: "Sin Pagar",
    invoiced: "facturado",
    new_site_visit: "Nueva Visita",
    schedule_site_visit: "Programar Visita",
    quick_estimate: "Presupuesto R\u00e1pido",
    schedule_job: "Programar Trabajo",
    view_details: "Ver Detalles",
    
    // Estimates
    estimates_title: "Presupuestos",
    total_estimates: "presupuestos totales",
    draft: "Borrador",
    sent: "Enviado",
    approved: "Aprobado",
    declined: "Rechazado",
    expired: "Vencido",
    all: "Todos",
    create_job: "Crear Trabajo",
    create_invoice: "Crear Factura",
    converted_to_job: "Convertido a Trabajo",
    view_job: "Ver Trabajo",
    send_to_client: "Enviar al Cliente",
    copy_link: "Copiar Enlace",
    preview_pdf: "Vista Previa PDF",
    download_pdf: "Descargar PDF",
    client_approval_link: "Enlace de Aprobaci\u00f3n",
    share_link_desc: "Comparta este enlace con su cliente para aprobar",
    preview: "Vista Previa",
    estimate_details: "Detalles del Presupuesto",
    scope_of_work: "Alcance del Trabajo",
    line_items: "Art\u00edculos",
    item: "Art\u00edculo",
    qty: "Cant",
    rate: "Precio",
    total: "Total",
    subtotal: "Subtotal",
    tax: "Impuesto",
    deposit_required: "Dep\u00f3sito Requerido",
    job_site: "Sitio del Trabajo",
    notes: "Notas",
    split: "Dividir",
    combine: "Combinar",
    split_estimate: "Dividir Presupuesto",
    combine_estimates: "Combinar Presupuestos",
    
    // Jobs
    jobs_title: "Trabajos",
    schedule_manage: "Programe y administre sus trabajos",
    new_job: "Nuevo Trabajo",
    calendar: "Calendario",
    active: "Activos",
    appointments: "Citas",
    scheduled: "Programado",
    in_progress: "En Progreso",
    completed: "Completado",
    on_hold: "En Espera",
    cancelled: "Cancelado",
    estimate_appointments: "Citas de Presupuesto",
    site_visits: "Visitas al sitio, recorridos previos al presupuesto y reuniones iniciales",
    new_appointment: "Nueva Cita",
    no_jobs_found: "No se encontraron trabajos",
    no_appointments: "No hay citas programadas",
    job_details: "Detalles del Trabajo",
    assigned_crew: "Equipo Asignado",
    internal_notes: "Notas Internas",
    linked_documents: "Documentos Vinculados",
    export_calendar: "Exportar a Calendario",
    open_in_maps: "Abrir en Mapas",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    list: "Lista",
    start_date: "Fecha de Inicio",
    end_date: "Fecha de Fin",
    job_type: "Tipo de Trabajo",
    mark_completed: "Marcar Completado",
    start_job: "Iniciar Trabajo",
    call_client: "Llamar al Cliente",
    get_directions: "Obtener Direcciones",
    visits: "Visitas",
    no_jobs_scheduled_yet: "No hay trabajos programados",
    start_by_scheduling: "Comience programando una visita al sitio",
    calendar_best_on_larger: "La vista de calendario funciona mejor en pantallas m\u00e1s grandes",
    invoice_linked: "Factura vinculada",
    no_site_visits_scheduled: "No hay visitas programadas",
    select_a_client: "Seleccionar un cliente",
    select_type: "Seleccionar tipo",
    schedule_repeat: "Programar este trabajo para que se repita autom\u00e1ticamente",
    weekly: "Semanal",
    biweekly: "Cada 2 Semanas",
    monthly: "Mensual",
    custom_interval: "Intervalo Personalizado",
    
    // Invoices
    invoices_title: "Facturas",
    total_invoices: "facturas totales",
    paid: "Pagado",
    partial: "Parcial",
    mark_as_paid: "Marcar como Pagado",
    record_payment: "Registrar Pago",
    payment_history: "Historial de Pagos",
    amount_due: "Monto Adeudado",
    amount_paid: "Monto Pagado",
    balance: "Saldo",
    balance_due: "Saldo Pendiente",
    due_date: "Fecha de Vencimiento",
    bill_to: "Facturar a",
    no_payments: "No hay pagos registrados",
    paid_in_full: "Pagado Completo",
    share_link: "Compartir Enlace",
    payment_recorded: "\u00a1Pago registrado!",
    revision_history: "Historial de Revisiones",
    
    // Customers/Clients
    customers_title: "Clientes",
    clients_title: "Clientes",
    total_customers: "clientes totales",
    add_new_customer: "Agregar Nuevo Cliente",
    add_new_client: "Agregar Nuevo Cliente",
    add_customer_btn: "Agregar Cliente",
    add_first_customer: "Agregue Su Primer Cliente",
    customer_details: "Detalles del Cliente",
    client_details: "Detalles del Cliente",
    contact_info: "Informaci\u00f3n de Contacto",
    name: "Nombre",
    email: "Correo Electr\u00f3nico",
    phone: "Tel\u00e9fono",
    address: "Direcci\u00f3n",
    search_placeholder: "Buscar por nombre, correo o tel\u00e9fono...",
    no_customers_found: "No se encontraron clientes",
    no_customers_yet: "A\u00fan no hay clientes",
    try_different_search: "Intente con un t\u00e9rmino diferente",
    add_first_desc: "Agregue su primer cliente para comenzar",
    customer_added: "\u00a1Cliente agregado!",
    no_contact_info: "Sin informaci\u00f3n de contacto",
    no_email: "Sin correo",
    no_phone: "Sin tel\u00e9fono",
    
    // Site Visits
    site_visits_title: "Visitas al Sitio",
    schedule_first_visit: "Programe su primera visita para comenzar",
    no_site_visits_found: "No se encontraron visitas",
    converted: "Convertido",
    filter_by_status: "Filtrar por estado",
    select_customer: "Seleccionar cliente",
    select_service_type: "Seleccionar tipo de servicio",
    enter_job_address: "Ingresar direcci\u00f3n del sitio",
    field_notes: "Notas de Campo",
    checklist: "Lista de Verificaci\u00f3n",
    photos: "Fotos",
    measurements: "Medidas",
    convert_to_estimate: "Convertir a Presupuesto",
    
    // Settings
    settings_title: "Configuraci\u00f3n",
    manage_settings: "Administre la configuraci\u00f3n de su organizaci\u00f3n",
    company: "Empresa",
    branding: "Marca",
    payments: "Pagos",
    terms: "T\u00e9rminos",
    defaults: "Predeterminados",
    users: "Usuarios",
    data: "Datos",
    language: "Idioma",
    business: "Negocio",
    team: "Equipo",
    documents: "Documentos",
    notifications: "Notificaciones",
    esignatures: "Firmas Electr\u00f3nicas",
    
    // Language Settings
    language_settings: "Configuraci\u00f3n de Idioma",
    default_language: "Idioma Predeterminado",
    default_language_desc: "Establezca el idioma predeterminado para todos los usuarios de su organizaci\u00f3n",
    user_language: "Tu Idioma",
    user_language_desc: "Anule el valor predeterminado de la organizaci\u00f3n solo para su cuenta",
    use_org_default: "Usar predeterminado de la organizaci\u00f3n",
    
    // Terms & Conditions
    terms_conditions: "T\u00e9rminos y Condiciones",
    terms_mode: "Modo de T\u00e9rminos",
    use_template: "Usar Plantilla Profesional (Recomendado)",
    template_desc: "Una plantilla de t\u00e9rminos completa y profesional que se completa autom\u00e1ticamente con la informaci\u00f3n de su empresa.",
    use_custom: "Usar T\u00e9rminos Personalizados",
    custom_desc: "Reemplace la plantilla completamente con sus propios t\u00e9rminos y condiciones personalizados.",
    template_preview: "Vista Previa de la Plantilla",
    auto_fills: "Se completa autom\u00e1ticamente con la informaci\u00f3n de su empresa",
    custom_terms: "T\u00e9rminos y Condiciones Personalizados",
    will_replace: "Reemplazar\u00e1 la plantilla completamente",
    require_acceptance: "Requerir Aceptaci\u00f3n de T\u00e9rminos",
    require_acceptance_desc: "Cuando est\u00e1 habilitado, los clientes deben marcar una casilla aceptando los t\u00e9rminos antes de aprobar un presupuesto.",
    save_terms: "Guardar Configuraci\u00f3n de T\u00e9rminos",
    
    // Checklist Settings
    checklist_settings: "Configuraci\u00f3n de Lista",
    checklist_settings_desc: "Configure los requisitos de lista de verificaci\u00f3n para conversiones de visitas y administre plantillas.",
    require_checklist: "Requerir Lista Antes de Conversi\u00f3n",
    require_checklist_desc: "Cuando est\u00e1 habilitado, la lista de verificaci\u00f3n de notas de campo debe completarse antes de convertir a presupuesto.",
    default_checklist_items: "Elementos Predeterminados",
    checklist_templates: "Plantillas de Lista",
    checklist_templates_desc: "Plantillas reutilizables para diferentes tipos de proyectos.",
    new_template: "Nueva Plantilla",
    no_templates_yet: "A\u00fan no hay plantillas personalizadas.",
    set_as_default: "Establecer como plantilla predeterminada para nuevas visitas",
    
    // Public pages
    estimate_valid: "Este presupuesto es v\u00e1lido por {days} d\u00edas desde la fecha anterior.",
    view_terms: "Ver T\u00e9rminos",
    hide_terms: "Ocultar T\u00e9rminos",
    agree_terms: "He le\u00eddo y acepto los T\u00e9rminos y Condiciones",
    agree_terms_desc: "Al marcar esta casilla, reconozco que he revisado los t\u00e9rminos y condiciones anteriores y acepto estar obligado por ellos.",
    approve_estimate: "Aprobar Presupuesto",
    estimate_approved: "\u00a1Presupuesto Aprobado!",
    estimate_declined: "Presupuesto Rechazado",
    thank_you: "\u00a1Gracias por considerar {company}!",
    questions: "\u00bfPreguntas? Cont\u00e1ctenos en {contact}",
    
    // Forms
    required_field: "Este campo es obligatorio",
    invalid_email: "Por favor ingrese un correo electr\u00f3nico v\u00e1lido",
    select_option: "Seleccione una opci\u00f3n",
    enter_amount: "Ingrese el monto",
    select_status: "Seleccione estado",
    
    // Dates & Time
    yesterday: "Ayer",
    tomorrow: "Ma\u00f1ana",
    this_week: "Esta Semana",
    this_month: "Este Mes",
    created: "Creado",
    
    // Status messages
    saved_successfully: "\u00a1Guardado exitosamente!",
    failed_to_save: "Error al guardar",
    failed_to_load: "Error al cargar los datos",
    deleted_successfully: "Eliminado exitosamente",
    failed_to_delete: "Error al eliminar",
    sent_successfully: "\u00a1Enviado exitosamente!",
    failed_to_send: "Error al enviar",
    link_copied: "\u00a1Enlace copiado!",
    pdf_downloaded: "\u00a1PDF descargado!",
    
    // Misc
    logout: "Cerrar Sesi\u00f3n",
    profile: "Perfil",
    help: "Ayuda",
    no_results: "No se encontraron resultados",
    unknown_client: "Cliente Desconocido",
    or: "o",
    of: "de",
    items: "elementos",
    none: "Ninguno",
    overdue: "Vencido",
    status: "Estado",
    type: "Tipo",
    date: "Fecha",
    amount: "Monto",
    description: "Descripci\u00f3n",
    actions: "Acciones",
    details: "Detalles",
    summary: "Resumen",
    template: "Plantilla",
    templates: "Plantillas",
    
    // Form Labels
    customer_label: "Cliente",
    service_type_label: "Tipo de Servicio",
    job_address_label: "Direcci\u00f3n del Trabajo",
    date_label: "Fecha",
    time_label: "Hora",
    assigned_to: "Asignado a",
    notes_label: "Notas",
    license_optional: "Licencia # (Opcional)",
    services_offered: "Servicios Ofrecidos",
    current_password: "Contrase\u00f1a Actual",
    new_password: "Nueva Contrase\u00f1a",
    confirm_password: "Confirmar Nueva Contrase\u00f1a",
    primary_color: "Color Primario",
    accent_color: "Color de Acento",
    first_name: "Nombre",
    last_name: "Apellido",
    role: "Rol",
    
    // Site Visit Detail
    complete_checklist_to_convert: "Complete la lista de verificaci\u00f3n para habilitar la conversi\u00f3n",
    delete_site_visit: "Eliminar Visita",
    convert_to_estimate_title: "Convertir a Presupuesto",
    
    // Jobs Page specific
    no_jobs_scheduled_yet: "No hay trabajos programados",
    start_by_scheduling: "Comience programando una visita al sitio",
    no_site_visits_scheduled: "No hay visitas programadas",
    invoice_linked: "Factura vinculada",
    calendar_best_on_larger: "La vista de calendario funciona mejor en pantallas grandes",
    
    // Invoice Detail
    demo_mode_payments: "Modo Demo: Pagos en l\u00ednea simulados.",
    tip_payment_link: "Consejo: Este enlace muestra su marca y opciones de pago.",
    summary_mode_hint: "Modo Resumen: Agregue secciones con descripciones. Ingrese el total al final.",
    
    // Client Detail
    archive_client: "Archivar cliente",
    materials_scope_ideas: "Ideas de Materiales y Alcance",
    timeline_label: "Cronograma",
    budget_label: "Presupuesto",
    priorities_label: "Prioridades",
    
    // Settings Page
    no_crew_members: "A\u00fan no hay miembros del equipo",
    no_esignatures: "A\u00fan no hay firmas electr\u00f3nicas",
    company_information: "Informaci\u00f3n de la Empresa",
    company_name: "Nombre de la Empresa",
    website_label: "Sitio Web",
    licensed_insured: "Licenciado y Asegurado",
    licensed_insured_desc: "Mostrar insignia de \"Licenciado y Asegurado\" en PDFs",
    change_password: "Cambiar Contrase\u00f1a",
    brand_colors: "Colores de Marca",
    logo_preview: "Vista previa del logo",
    estimate_settings: "Configuraci\u00f3n de Presupuestos",
    estimate_display_modes: "Modos de Visualizaci\u00f3n",
    estimate_modes_desc: "Elija qu\u00e9 formatos de presupuesto est\u00e1n disponibles al crear presupuestos.",
    save_estimate_modes: "Guardar Modos",
    line_items_during_visit: "Art\u00edculos Durante la Visita",
    line_items_mode_desc: "Elija c\u00f3mo aparecen los art\u00edculos al crear un presupuesto.",
    required: "Requerido",
    optional: "Opcional",
    hidden: "Oculto",
    terms_conditions_section: "T\u00e9rminos y Condiciones",
    estimate_terms: "T\u00e9rminos del Presupuesto",
    invoice_terms: "T\u00e9rminos de la Factura",
    
    // Misc page elements
    no_data: "No hay datos disponibles",
    confirm_delete: "\u00bfEst\u00e1 seguro de que desea eliminar esto?",
    this_action_cannot_be_undone: "Esta acci\u00f3n no se puede deshacer.",
    sign_in: "Iniciar Sesi\u00f3n",
    log_out: "Cerrar Sesi\u00f3n",
    online: "En l\u00ednea",
    offline: "Sin conexi\u00f3n",
  }
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '\ud83c\uddfa\ud83c\uddf8' },
  { code: 'es', name: 'Espa\u00f1ol', flag: '\ud83c\uddea\ud83c\uddf8' },
];

export default translations;
